import React, {useEffect, useState } from 'react'
import useStateRef from "react-usestateref";
import Helper from '../Helper';
import { APPLICATION_JSON } from '../../middleware/types';
export const AdditionalInformation = (props) => {
    const [additionalDetails, setAdditionalDetails, additionalDetailsRef] = useStateRef('');
    const [newJDEAccount, setNewJDEAccount, newJDEAccountRef] = useState('');
    const [newBillTo, setNewBillTo, newBillToRef] = useStateRef('');
    const [JDEShipToAccount, setJDEShipToAccount, JDEShipToAccountRef] = useStateRef('');
    const [JDEShipToAccountMap, setJDEShipToAccountMap, JDEShipToAccountMapRef] = useStateRef('');
    const [JDEContactAccount, setJDEContactAccount, JDEContactAccountRef] = useStateRef('');
    const [JDEContactAccountMap, setJDEContactAccountMap, JDEContactAccountMapRef] = useStateRef('');
    const [orgDetails, setOrgDetails, orgDetailsRef] = useStateRef('');
    const [showButtons, setShowButtons, showButtonsRef] = useStateRef(true);
    const [actionType, setActionType, actionTypeRef] = useStateRef('');
    const [isDisableJDE, setIsDisableJDE, isDisableJDERef] = useStateRef(false);
    const [isDisableUpdateShipping, setIsDisableUpdateShipping, isDisableUpdateShippingRef] = useStateRef(true);
    const [addressInfo, setAddressInfo, addressInfoRef] = useStateRef('');
    const [addressInfoList, setAddressInfoList, addressInfoListRef] = useStateRef('');
    const [showAddressInfo, setShowAddressInfo, showAddressInfoRef] = useStateRef(true);
    const [currentShipAddressId, setCurrentShipAddressId, currentShipAddressIdRef] = useStateRef('')
    const [shipToAddressFromOrder, setShipToAddressFromOrder, shipToAddressFromOrderRef] = useStateRef('')
    const [searchAddress, setSearchAddress, searchAddressRef] = useStateRef([]);
    useEffect(()=>{

        setAdditionalDetails(props.additionalInformation && props.additionalInformation);
        if(additionalDetailsRef.current){
            setActionType(additionalDetailsRef.current.actionType ? additionalDetailsRef.current.actionType: '');
            setJDEShipToAccount(additionalDetailsRef.current.JDEShipToAccount ? additionalDetailsRef.current.JDEShipToAccount:'');
            setJDEShipToAccountMap(additionalDetailsRef.current.response && additionalDetailsRef.current.response.JDEShipToAccountMap ? additionalDetailsRef.current.response.JDEShipToAccountMap:'');
            if(Object.keys(JDEShipToAccountMapRef.current).length === 0){
                console.log('JDEShipToAccountMapRef.current..//',JDEShipToAccountMapRef.current);
                setJDEShipToAccountMap('');
            }
            if(JDEShipToAccountRef.current =='' && Object.keys(JDEShipToAccountMapRef.current).length === 0){               
            setShowAddressInfo(true);
            setAddressInfo(additionalDetailsRef.current.response && additionalDetailsRef.current.response.addressInfoMap? additionalDetailsRef.current.response.addressInfoMap : '');
            setAddressInfoList(additionalDetailsRef.current.response && additionalDetailsRef.current.response.addressInfoMap && additionalDetailsRef.current.response.addressInfoMap.addressInfoList? additionalDetailsRef.current.response.addressInfoMap.addressInfoList : '');
            setSearchAddress(additionalDetailsRef.current.response && additionalDetailsRef.current.response.addressInfoMap && additionalDetailsRef.current.response.addressInfoMap.addressInfoList? additionalDetailsRef.current.response.addressInfoMap.addressInfoList : '');
        }
            if(JDEShipToAccountRef.current == '' && JDEShipToAccountMapRef.current == '' && addressInfoRef.current =='' && addressInfoListRef.current==''){
                setJDEShipToAccount('Not Applicable');
            }
            setJDEContactAccountMap(additionalDetailsRef?.current?.response?.JDEContactAccountMap ? additionalDetailsRef.current.response.JDEContactAccountMap: '')
           console.log('additionalDetails...',additionalDetailsRef.current && additionalDetailsRef.current);
            console.log('JDEContactAccount',additionalDetailsRef?.current?.response?.JDEContactAccount ? additionalDetailsRef.current.response.JDEContactAccount: 'JDEContactAccount is empty');
            setJDEContactAccount(additionalDetailsRef?.current?.response?.JDEContactAccount ? additionalDetailsRef.current?.response?.JDEContactAccount:additionalDetailsRef?.current?.JDEContactAccount ? additionalDetailsRef?.current?.JDEContactAccount:'');
            if(JDEContactAccountMapRef.current == '' && JDEContactAccountRef.current == ''){
                setJDEContactAccount('Not Applicable');
            }
        }
        if(additionalDetailsRef.current.newBillToAddress){
            setNewBillTo(additionalDetailsRef.current.newBillToAddress);    
        }
        if(actionTypeRef.current && actionTypeRef.current ==='rejectedProfile'){
            setIsDisableJDE(true);
            document.getElementById('searchOrg').classList.add('disabled');
        }
        if(actionTypeRef?.current ==='ordersSyncRequired'){
        document.getElementById(props.userId+'_error2').classList.remove('d-none');
        document.getElementById(props.userId+'_error2').classList.add('d-block');
        }

    },[])

    const handleChangeJDE = (event)=>{
        setNewJDEAccount(event.target.value);
    }

    async function getSearchOrganizationDetails(event){
        event.preventDefault();
        var formData = new FormData(event.target);
        const formValue = Object.fromEntries(formData.entries());
        const inputMap = JSON.stringify(formValue);
        if(formValue?.jdeNumber === ''){
            document.getElementById(props.userId+'_error1').classList.remove('d-none');
            document.getElementById(props.userId+'_error').classList.add('d-none');
            document.getElementById(props.userId+'_error1').classList.add('d-block');
   
        }else{
            var actionUrl = "api/rest/cb/profile/get-organization-details";
            var url = `${window.location.protocol}//${window.location.hostname}/${actionUrl}`
    
            var res = await Helper.fetchCallFunction(url, "POST", false, APPLICATION_JSON, inputMap)
    
            if (res.response != null) {
                setNewBillTo(res.response.orgSearchList.newBillTo);
                setOrgDetails(res.response.orgSearchList);
                getShippingDetails();
                if(JDEShipToAccountRef.current === 'Not Applicable' && actionTypeRef.current !== 'ordersSyncRequired'){
                    document.getElementById('acceptTempB2I').classList.remove('disabled');
                }
    
               
                document.getElementById('searchOrg').classList.add('d-none');
                document.getElementById('editOrg').classList.remove('d-none');
                document.getElementById(props.userId+'_error').classList.add('d-none');
                document.getElementById(props.userId+'_error1').classList.add('d-none');
    
            } else {
                document.getElementById(props.userId+'_error').classList.remove('d-none');
                document.getElementById(props.userId+'_error').classList.add('d-block');
                document.getElementById(props.userId+'_error1').classList.add('d-none')
            }

        }
        }

        async function getShippingDetails(){
            var actionUrl = 'api/rest/cb/profile/get-shipping-address-tempB2I'
            var url = `${window.location.protocol}//${window.location.hostname}/${actionUrl}`;
            var res = await Helper.fetchCallFunction(url, "GET", false, APPLICATION_JSON, null)

            if (res.response != null) {
                setAddressInfo(res.response.response && res.response.response.addressInfoMap)
                setAddressInfoList(res.response.response && res.response.response.addressInfoMap && res.response.response.addressInfoMap.addressInfoList ? res.response.response.addressInfoMap.addressInfoList :'');
                setSearchAddress(res.response.response && res.response.response.addressInfoMap && res.response.response.addressInfoMap.addressInfoList ? res.response.response.addressInfoMap.addressInfoList :'');
                setJDEContactAccountMap(res.response.response && res.response.response.JDEContactAccountMap?res.response.response.JDEContactAccountMap:'')
                setShowAddressInfo(true);
                if(addressInfoListRef.current && showAddressInfoRef.current){
                    document.getElementById('jde-ship-to-account').classList.add('d-none');
                }
            }else {
                console.log('res.response...', res.response);
            }
        }
        async function handleAccept(event){
            event.preventDefault();
            // var selectedAddressId = document.getElementById('address-entry').value;
            var saveShippingData = additionalDetailsRef.current.saveShippingData;
            var userId = props.userId;
            if(JDEShipToAccountRef.current === 'Not Applicable'){
                var inputMap = {'saveShippingData':saveShippingData, 'userId':userId}
            }else{
                var inputMap = {'saveShippingData':saveShippingData, 'selectedAddressId':currentShipAddressIdRef.current, 'userId':userId}
            }      
            var actionUrl = "api/rest/cb/profile/accept-tempB2I";
            var url = `${window.location.protocol}//${window.location.hostname}/${actionUrl}`
            inputMap = JSON.stringify(inputMap);
            var res = await Helper.fetchCallFunction(url, "POST", false, APPLICATION_JSON, inputMap)
        if (res.response != null) {
            if(res.response.status ==='success'){

                setActionType('acceptedOrder');
                setShowButtons(false);
                document.getElementById('accepted-label').classList.remove('d-none');
                document.getElementById('accepted-label').classList.add('d-block');
                document.getElementById('edit-ship-to-account').classList.add('d-none');
                if(props.handleOrderDetails){
                    props.handleOrderDetails()
                }
            }
           
        } else {
                console.log('res.response...', res.response);
            }
        }

        async function handleReject(event){
            event.preventDefault();
            var inputMap = {testInput:'true'};
            inputMap = JSON.stringify(inputMap);
            var actionUrl = "api/rest/cb/profile/reject-tempB2I";
            var url = `${window.location.protocol}//${window.location.hostname}/${actionUrl}`
            var res = await Helper.fetchCallFunction(url, "POST", false, APPLICATION_JSON, inputMap)
        if (res.response != null) {
            setShowButtons(false);
            document.getElementById('rejected-label').classList.remove('d-none');
            document.getElementById('rejected-label').classList.add('d-block');
            setIsDisableJDE(true);
            document.getElementById('searchOrg').classList.add('disabled');
            console.log('res.response...', res.response);
            } else {
                console.log('res.response...', res.response);
            }
        }

        async function handleEditOrg(event){
            event.preventDefault();
            setNewBillTo('');
            setOrgDetails('');
             document.getElementById('acceptTempB2I').classList.add('disabled');
             document.getElementById('searchOrg').classList.remove('d-none');
             document.getElementById('editOrg').classList.add('d-none');
             setAddressInfoList('');
             setJDEShipToAccountMap('');
             document.getElementById('jde-ship-to-account').classList.remove('d-none');
             document.getElementById('edit-ship-to-account').classList.add('d-none');
        }

        function handleSelectShipToAccount(event, address){
            console.log('handleSelectShipToAccount called....');
            event.preventDefault();
            console.log('address..',address, );
            setSearchAddress(addressInfoListRef.current);
            if(address){
                setCurrentShipAddressId(address.addrRepId);
                
                var shipToAccount = {
                    "city":address.city,
                    "address1":address.address1,
                    "companyName": address.cName,
                    "postalCode":address.postalCode,
                    "stateAddress":address.state
                }

            }else{
                 setCurrentShipAddressId('shipping');
                
                var shipToAccount = {
                    "city":addressInfoRef.current && addressInfoRef.current.city,
                    "address1":addressInfoRef.current && addressInfoRef.current.address1,
                     "companyName": addressInfoRef.current && addressInfoRef.current.companyName,
                    "postalCode":addressInfoRef.current && addressInfoRef.current.postalCode,
                    "stateAddress":addressInfoRef.current && addressInfoRef.current.state
                }
            }
            document.getElementById('update-shipping') && document.getElementById('update-shipping').classList.remove('disabled');
            document.getElementById('acceptTempB2I') && document.getElementById('acceptTempB2I').classList.remove('disabled');
             setJDEShipToAccountMap(shipToAccount);
             console.log("JDEShipToAccountMapRef...,",JDEShipToAccountMapRef.current);
             setShowAddressInfo(false);
             document.getElementById('edit-ship-to-account') && document.getElementById('edit-ship-to-account').classList.remove('d-none');
        }

        function handleEditShipToAccount(event){
            event.preventDefault();
            setJDEShipToAccountMap('');
            setShowAddressInfo(true);
            document.getElementById('edit-ship-to-account').classList.add('d-none');
        }
        async function handleUpdateShipping(event){
            event.preventDefault();
            // var selectedAddressId = document.getElementById('address-entry').value;
            var saveShippingData = additionalDetailsRef.current.saveShippingData;
            var userId = props.userId;
            
            var inputMap = {'saveShippingData':saveShippingData, 'selectedAddressId':currentShipAddressIdRef.current, 'userId':userId}
                  
            var actionUrl = "api/rest/cb/profile/accept-tempB2I";
            var url = `${window.location.protocol}//${window.location.hostname}/${actionUrl}`
            inputMap = JSON.stringify(inputMap);
            var res = await Helper.fetchCallFunction(url, "POST", false, APPLICATION_JSON, inputMap)
        if (res.response != null) {
            if(res.response.status ==='success'){
                
                setActionType('acceptedOrder');
                setShowButtons(false);
                document.getElementById('accepted-label').classList.remove('d-none');
                document.getElementById('accepted-label').classList.add('d-block');
               
            }
           
        } else {
                console.log('res.response...', res.response);
            }
        }

        function handleSearchAddress(event){
            var searchKey = event.target.value;
            console.log('searchKey...',searchKey);
            if(searchKey.length >2){
                var regKeyWordMatch  = new RegExp(searchKey,'i');
                var searchedNamesArr = [];
                addressInfoListRef.current.map((address,index)=>{
                   
                    if(address.cName.match(regKeyWordMatch) || address.address1.match(regKeyWordMatch) || address.city.match(regKeyWordMatch) || address.postalCode.match(regKeyWordMatch)){
                        console.log('keyword matching....');
                        searchedNamesArr.push(address);
                    }
                })
                if(searchedNamesArr.length>0){
                    setSearchAddress(searchedNamesArr);
                }else{
                    setSearchAddress([]);
                }
                console.log('searchedNamesArr..',searchedNamesArr);
                
            }else{
                setSearchAddress(addressInfoListRef.current);
            }
            console.log('finalSearchResult..',searchAddressRef.current);
        }

        function handleSelectSearchAddress(event){
            if(event.target.value ==='Find an address...')
            document.getElementById('inst').value ='';
        }

return(
    <div id="additionalInformation" className="orderFly c-csr-add-info px-2">
        <div id={props.userId+'_error2'}  className='alert alert-danger d-none' dangerouslySetInnerHTML={{__html:additionalDetailsRef.current?.alertMessage}}></div>
        <div id={props.userId+'_error'} className='alert alert-danger col-12 d-none' >csr-no-search-parameter</div>
        <div id={props.userId+'_error1'} className='alert alert-danger col-12 d-none' >Enter New JDE Account Number</div>
                                            <div className="row">
                                                <div className="col-12 col-md-12">
                                                    <h2 className="c-csr-add-info-title c-csr-main-heading">Additional Information</h2>
                                                </div>
                                            </div>
                                            <div className="row mb-5">
                                                <div className="col-12 col-md-9">
                                                    <p className="c-csr-add-info-left">
                                                    School/Organization Name:
                                                         <span className="c-color-red"> {additionalDetailsRef.current && additionalDetailsRef.current.orgName}</span>
                                                    </p>
                                                    <p className="c-csr-add-info-left">
                                                    Street Address:
                                                        <span className="c-color-red"> {additionalDetailsRef.current && additionalDetailsRef.current.b2iTempStreetAddress}</span>
                                                    </p>
                                                    <p className="c-csr-add-info-left">
                                                        City:
                                                        <span className="c-color-red"> {additionalDetailsRef.current && additionalDetailsRef.current.b2iTempCity}</span>
                                                    </p>
                                                    <p className="c-csr-add-info-left">
                                                        State:
                                                        <span className="c-color-red"> {additionalDetailsRef.current && additionalDetailsRef.current.b2iTempState}</span>
                                                    </p>
                                                    <p className="c-csr-add-info-left">
                                                        Comments:
                                                        <span className="c-color-red"> {additionalDetailsRef.current && additionalDetailsRef.current.orgAddress}</span>
                                                    </p>
                                                </div>
                                                <div className="col-12 col-md-3">
                                                    <div id="orderControls" className="text-end c-csr-add-info-actions"> 
                                                    <div id='accepted-label' className='action-label accept d-none'>ACCEPTED</div> 
                                                    <div id='rejected-label' className='action-label reject d-none'>REJECTED</div> 
                                                   {showButtonsRef.current &&
                                                        <>
                                                            {actionTypeRef.current &&  <>
                                                        {actionTypeRef.current === 'acceptedOrder' &&   <div className='action-label accept'>ACCEPTED</div>   }
                                                        {actionTypeRef.current === 'acceptRejectButtons' || actionTypeRef.current === 'actionOnlyOnProfile'?
                                                       <>
                                                             <input id="acceptTempB2I" className={JDEShipToAccountMapRef.current?"btn btn-success":"btn btn-success disabled"} type="button" onClick={handleAccept} value="Accept"></input>   
                                                             <input id="rejectTempB2I" className="btn btn-danger" type="button" onClick={handleReject} value="Reject"></input>   
                                                       </>:""}
                                                       {actionTypeRef.current === 'ordersSyncRequired'?
                                                       <>
                                                             <input id="acceptTempB2I" className={"btn btn-success disabled"} type="button" onClick={handleAccept} value="Accept"></input>   
                                                             <input id="rejectTempB2I" className="btn btn-danger" type="button" onClick={handleReject} value="Reject"></input>   
                                                       </>:""}
                                                       {actionTypeRef.current === 'updateAddressInOrder' && 
                                                           <>
                                                               <div id="accepted" className='action-label accept' style={{display: "inline-block"}}>ACCEPTED</div>
                                                               <input id="update-shipping" onClick={handleUpdateShipping} className={JDEShipToAccountMapRef.current?"btn btn-success mt-0":"btn btn-success mt-0 disabled"} type="button" value="Update Shipping"></input>
                                                           </>
                                                       }
                                                       {actionTypeRef.current === 'rejectedProfile' &&   <div className='action-label reject'>REJECTED</div>   }
                                                      
                                                       </>
                                                    }
                                                        </>
                                                   }
                                                    
                                                     
                                                    </div>
                                                </div>
                                            </div>
                                                <div className="row g-md-4">
                                                    <div className="col-12 col-md-4">
                                                            <form id="csr_user_org_1" method="post" onSubmit={getSearchOrganizationDetails} name="csr_user_org_1" >
                                                                <div className="row g-1 mb-md-2">
                                                                    <label className="col-md-3 col-form-label c-color-red">
                                                                    NEW JDE ACCOUNT#:
                                                                    </label>
                                                                    <div className="col-9 col-md-5">
                                                                        {additionalDetailsRef.current && additionalDetailsRef.current.newJDEAccount ? 
                                                                                 <input id="jdeNumber" className="form-control" name="jdeNumber" value={additionalDetailsRef.current.newJDEAccount} type="text" ></input>    
                                                                                 :
                                                                                 isDisableJDERef.current?<input id="jdeNumber" className="btn disabled" name="jdeNumber" type="text" disabled></input>:
                                                                                <input id="jdeNumber" className="form-control" name="jdeNumber" type="text"></input>
                                                                                   
                                                                        }
                                                                       
                                                                    </div>
                                                                    <div className="col-2 col-md-2">
                                                                        {actionTypeRef.current ==='rejectedProfile' ?
                                                                                <input id="searchOrg" className="btn disabled" type="submit" value="Search" ></input>
                                                                            :
                                                                            actionTypeRef.current !== 'acceptedOrder' && actionTypeRef.current !== 'updateAddressInOrder' ?
                                                                            <>
                                                                                <input id="searchOrg" className="btn btn-primary c-btn-search" type="submit" value="Search" ></input>
                                                                                <input id="editOrg" className="btn btn-primary c-btn-search d-none" onClick={handleEditOrg} type="submit" value="Edit"></input>
                                                                            </>
                                                                            :    
                                                                            ''
                                                                        }
                                                                       
                                                                    </div>
                                                                </div>
                                                            </form>
                                                            {newBillToRef.current ? 
                                                                <> 
                                                                    <div className='row g-1'>
                                                                <label className='col-md-3 col-form-label c-color-red' >NEW Bill To:</label>
                                                                <div className='col-2 col-md-7 c-color-red'>
                                                                    <address className='c-color-red'>
                                                                        {newBillToRef.current.name && newBillToRef.current.name}
                                                                        <br/>
                                                                        {newBillToRef.current.address1 && newBillToRef.current.address1}
                                                                        <br/>
                                                                        {newBillToRef.current.address2 && newBillToRef.current.address2}
                                                                        <br/>
                                                                        {newBillToRef.current.city && newBillToRef.current.city} {newBillToRef.current.state && ' '+newBillToRef.current.state} {newBillToRef.current.postalCode && ' '+newBillToRef.current.postalCode}
                                                                    </address>
                                                                    <br/>
                                                                </div>
                                                            </div>
                                                            <div className='row g-1'>
                                                                <label className='col-md-3 col-form-label c-color-red' >New Price List:</label>
                                                                <div className='col-2 col-md-7 c-color-red'>{orgDetailsRef.current && orgDetailsRef.current.newPriceList? orgDetailsRef.current.newPriceList: additionalDetailsRef.current.newPriceList}</div>             
                                                            </div>
                                                                </>:''}
                                                            
                                                    </div>
                                                    <div className="col-12 col-md-8">
                                                        <div className='row'>
                                                           
                                                                <div className="col-12 col-md-6">
                                                                    <div className="row g-1 mb-md-2">
                                                                        <label className="col-md-3 col-form-label c-color-red">
                                                                            JDE Ship To Account :
                                                                        </label>
                                                                        <div className="col-9 col-md-9">
                                                                            <input id='edit-ship-to-account' className='btn btn-primary c-btn-search d-none' onClick={handleEditShipToAccount} type='button' value='Edit'></input>
                                                                            {JDEShipToAccountRef.current && <span id='jde-ship-to-account' className="c-csr-label c-color-red">{ JDEShipToAccountRef.current}</span>}
                                                                        </div>
                                                                    </div>
                                                                    {Object.keys(JDEShipToAccountMapRef.current).length !== 0 && 
                                                                    <div className='b2iAddressInfo-selected'>                                                              
                                                                                <span className="c-csr-label c-color-red">
                                                                                    {JDEShipToAccountMapRef.current.companyName ? JDEShipToAccountMapRef.current.companyName:''}
                                                                                    <br/>
                                                                                    {JDEShipToAccountMapRef.current.address1 ? JDEShipToAccountMapRef.current.address1:''}
                                                                                    <br/>
                                                                                    {JDEShipToAccountMapRef.current?.address2?<>{JDEShipToAccountMapRef.current.address2 }<br/></>:''}
                                                                                    {JDEShipToAccountMapRef.current.city && JDEShipToAccountMapRef.current.city},&nbsp; {JDEShipToAccountMapRef.current.stateAddress && JDEShipToAccountMapRef.current.stateAddress}&nbsp;{JDEShipToAccountMapRef.current.postalCode && JDEShipToAccountMapRef.current.postalCode}
                                                                                </span>
                                                                    </div>}
                                                                    {showAddressInfoRef.current && addressInfoListRef.current ?
                                                                            <div id='b2iAddressInfo'>
                                                                            <div className='shipping-box'>
                                                                                <div className='shipping-option' id='address-institution'>
                                                                                    <div>
                                                                                        <input className='shipping-search' id='inst' type='text' onChange={handleSearchAddress} onSelect={handleSelectSearchAddress} defaultValue='Find an address...'></input>
                                                                                    </div>
                                                                                    <div className='shipping-details shipping-scroll'>
                                                                                        <ul className='shipping-list'>
                                                                                            <li id='addrId_shipping' className='fw-bold'>
                                                                                                <label className='form-check'>
                                                                                                    <input type='radio' id='address-entry' name='i-address-entry' addressType='address-from-order' onClick={(event)=>handleSelectShipToAccount(event)}  value='453814763'></input>
                                                                                                    Use Ship to Address from Order
                                                                                                </label>
                                                                                            </li>
                                                                                            
                                                                                               {searchAddressRef.current.map((address,index)=>{
                                                                                                return( 
                                                                                                 <li >
                                                                                                    <label className='form-check'>
                                                                                                        <input type='radio' id='address-entry' name='i-address-entry' addressType='address-from-list' onClick={(event)=>handleSelectShipToAccount(event, address)}  value={address.addrRepId && address.addrRepId}></input>
                                                                                                        {address.cName && address.cName}
                                                                                                        <br/>
                                                                                                        {address.address1 && address.address1}
                                                                                                        <br/>
                                                                                                        {address.city && address.city},&nbsp;{address.state && address.state}&nbsp;{address.postalCode && address.postalCode}
                                                                                                    </label>                                                                 
                                                                                                </li>     )})}                                                                  
                                                                                        
                                                                                        </ul>                 
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>  
                                                                        :''  
                                                                    }
                                                                
                                                                    <div id='b2iAddressInfo-selected' className='row'></div>
                                                                </div>

                                                                <div className="col-12 col-md-6">
                                                                    <div id='contactInitialDisplay'>
                                                                        <div className="row g-1 mb-md-2">
                                                                            <label className="col-md-3 col-form-label c-color-red">
                                                                                JDE Contact Account :
                                                                            </label>
                                                                            <div className="col-9 col-md-9">
                                                                            {JDEContactAccountRef.current  && !JDEShipToAccountMapRef.current && <span className="c-csr-label c-color-red">{JDEContactAccountRef.current}</span>}
                                                                            </div>
                                                                        </div>
                                                                        <div className='row'>
                                                                            
                                                                            {JDEContactAccountMapRef.current && JDEShipToAccountMapRef.current &&
                                                                                <span className="c-csr-label c-color-red">
                                                                                    {JDEContactAccountMapRef.current.firstName && JDEContactAccountMapRef.current.firstName}&nbsp;{JDEContactAccountMapRef.current.lastName && JDEContactAccountMapRef.current.lastName}
                                                                                    <br/>
                                                                                    {JDEContactAccountMapRef.current?.location && <>
                                                                                        {JDEContactAccountMapRef.current.location}
                                                                                        <br/>
                                                                                    </>
                                                                                    }          
                                                                                    {JDEContactAccountMapRef.current.recipientEmail && JDEContactAccountMapRef.current.recipientEmail}
                                                                                    <br/>
                                                                                    {JDEContactAccountMapRef.current.primaryPhone && JDEContactAccountMapRef.current.primaryPhone}
                                                                                </span>
                                                                            }
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            
                                                        </div>
                                                    </div>
                                                </div>
                                        </div>
)
}